module.exports = __webpack_public_path__ + "static/media/n5.8cd74073.png";